import { createSelector } from 'reselect'
import { getWorkspaceID } from '../globals'
import { getArgN } from './utils'

export const getAllMap = state => state.workspaces
export const getIdentities = state => state.identities

/**
 * Get workspace by ID
 */

export const get = createSelector([ getAllMap, getArgN(1) ], (workspaces = {}, workspaceID) => {
  if (!workspaceID) throw new Error(`Missing workspaceID: ${workspaceID} (${typeof workspaceID})`)
  return workspaces[workspaceID]
})

export const getAll = createSelector([ getAllMap ], (workspaces) => {
  return Object.entries(workspaces)
})

export const toName = (user, workspace) => {
  return workspace.name
}

export const getName = createSelector([ get ], toName)
export const getCurrentName = (state) => {
  const workspace = getCurrent(state)
  if (!workspace) return
  return workspace.name
}

export const getCurrent = state => {
  return get(state, getWorkspaceID())
}

export const getAllUsers = createSelector([ get, getIdentities ], (workspace, identities) => {
  if (!workspace) return []
  return workspace.users.map(email => identities[email]).filter(Boolean)
})

export const getMembers = createSelector([ get, getAllUsers ], (workspace, allUsers) => {
  if (!workspace) return []
  return allUsers.filter(user => {
    const access = user.workspaces[workspace.id]
    return access && !access.isOwner
  })
})

export const getOwners = createSelector([ get, getAllUsers ], (workspace, allUsers) => {
  if (!workspace) return []
  return allUsers.filter(user => {
    const access = user.workspaces[workspace.id]
    return access && access.isOwner
  })
})



// WEBPACK FOOTER //
// ../webmango-core/selectors/workspace.js